import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { ValidationStats } from "../types";
import * as styles from "./styles_vanilla.css";

interface DataValidationStatsProps {
  stats?: ValidationStats;
}

const DataValidationStats: React.FC<DataValidationStatsProps> = ({ stats }) => {
  // Provide default values when stats is undefined
  const defaultStats: ValidationStats = {
    totalRecords: 0,
    validRecords: 0,
    criticalErrors: 0,
    warnings: 0,
  };

  const currentStats = stats || defaultStats;

  const statItems: Array<{
    value: number;
    label: string;
    variant: "primary" | "success" | "danger" | "warning";
  }> = [
    {
      value: currentStats.totalRecords,
      label: "Total Records",
      variant: "primary",
    },
    {
      value: currentStats.validRecords,
      label: "Valid Records",
      variant: "success",
    },
    {
      value: currentStats.criticalErrors,
      label: "Critical Errors",
      variant: "danger",
    },
    {
      value: currentStats.warnings,
      label: "Warnings",
      variant: "warning",
    },
  ];

  return (
    <Flex className={styles.statsContainer}>
      {statItems.map((item, index) => (
        <Flex
          key={index}
          className={`${styles.statCard} ${styles.statCardVariants[item.variant]}`}
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Text
            variant="h2"
            className={`${styles.statValue} ${styles.textColorVariants[item.variant]}`}
          >
            {item.value}
          </Text>
          <Text
            variant="regular-sm"
            className={`${styles.statLabel} ${styles.textColorVariants[item.variant]}`}
          >
            {item.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default DataValidationStats;
